export const button = {
    position: 'fixed',
    bottom: { xs: 20, md: 32 },
    right: { xs: 20, md: 32 },
    width: 44,
    height: 44,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--ecal-navy)',
    border: '1px solid rgba(187,188,188,0.18)',
    color: 'var(--ecal-white)',
    cursor: 'pointer',
    zIndex: 20,
    boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
    transition: 'transform 0.18s ease, background 0.18s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        background: 'rgba(1,1,52,0.9)',
    },
};
